/** @file Deletes a socket and its generated bones; their slots move to the parent bone, items stay put. */
import { defineCommand } from '../defineCommand';
import { defineRemove } from '../_shared/defineRemove';
import { rehomeSlots } from './rehomeSlots';

const remove = defineRemove({
  domain: 'socket',
  kind: 'socket',
  description:
    "Delete a socket with its socket and grip-2 bones; slots on those bones move to the socket's parent bone and their attachments are recomposed so they stay in place (mounts are dropped).",
});

/** socket.delete: re-homes the slots of the generated bones (items recomposed in place), then the factory removal. */
export const command = defineCommand({
  ...remove,
  apply(draft, input, ctx) {
    const socket = draft.sockets[ctx.resolve('socket', input.target)];
    if (socket) {
      const generated = new Set([socket.bone, socket.grip2Bone]);
      rehomeSlots(draft, socket, Object.entries(draft.slots).filter(([, slot]) => generated.has(slot.bone)).map(([id]) => id));
    }
    remove.apply(draft, input, ctx);
  },
});
